import makeStyles from "@mui/styles/makeStyles";
import { Bold, SemiBold } from "../../utils";
export const useStyles = makeStyles((theme) => ({
    content: {
        height: "calc(100vh - 320px)",
        // (size) => (size?.height - 125),
        overflow: "auto",
        padding: "16px",
        rowGap: "16px",
    },
    card: {
        border: "2px solid white",
        borderRadius: theme.palette.borderRadius,
        backgroundColor: "white",
    },
    profileDetailCard: {
        backgroundColor: "#F5F7FA",
        padding: "16px 16px 16px 0px",
        borderRadius: "6px"
    },
    image: {
        height: "120px",
        width: "120px",
        borderRadius: "50%",
        margin: "4px",
        objectFit: "fill"
    },
    profileImageDiv: {
        display: "flex",
        justifyContent: "center",
        position: "relative",
        borderRight: "1px solid #00000014",
        padding: "4px",
    },
    profileDetailDiv: {
        padding: "0px 12px"
    },
    title: {
        color: theme.typography.color.secondary,
        fontSize:"0.75rem",
        fontFamily: Bold
    },
    heading: {
        color: theme.typography.color.tertiary,
        fontSize:"0.875rem",
        fontFamily: SemiBold,
        textTransform: "capitalize"
    },
    sub: {
        color: theme.typography.color.primary,
        fontSize:"0.875rem",
        fontFamily: SemiBold,
        textTransform: "capitalize"
    },
    subMob: {
        color: theme.typography.color.primary,
        fontSize:"0.875rem",
        fontFamily: SemiBold,
        textTransform: "capitalize",
        direction: "ltr",
        textAlign: "-webkit-match-parent"
    },
    sub1: {
        color: theme.typography.color.primary,
        fontSize:"0.75rem",
        fontFamily: SemiBold,
        textTransform: "capitalize"
    },
    mapDiv: {
        borderRadius: theme.palette.borderRadius,
        overflow: "hidden",
        height: "200px"
    },
    addressDiv: {
        padding: "12px",
        minHeight: "200px",
        borderTop: "1px solid #E4E8EE",
        borderBottom: "1px solid #E4E8EE",
        borderRadius: "5px"
    },
    addressDiv2: {
        padding: "12px",
        borderBottom: "1px solid #E4E8EE",
        borderRadius: "5px"
    },
    contactDiv: {
        padding: "12px",
        minHeight: "200px",
        border: "1px solid #E4E8EE",
        borderRadius: "5px"
    },
}));